import script from "./CustDataPetTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustDataPetTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./CustDataPetTableRow.vue?vue&type=style&index=0&id=58711fd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58711fd0"]])

export default __exports__